module.exports = __webpack_public_path__ + "img/W_HIO.3c83e1b0.svg";